import { faChevronRight, faEnvelopeOpenText, faEye, faEyeSlash, faFolderOpen, faPaperPlane, faTrash, faTrashAlt, faTrashRestore } from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import axios from 'axios';
import TopBar from 'components/Layout/TopBar';
import {logError} from 'components/Utils/FormatData';
import {URL_API} from 'utils/globalConfig';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {useAlert} from 'react-alert';
import {ClipLoader} from 'react-spinners';
import useAuthz from '../../hooks/useAuthz';
import MySelect from "../../components/Layout/MySelect";
import useMessage from "../../hooks/useMessage";
import {useNavigate} from "react-router";
import MyButton from "../../components/Layout/MyButton";
import {Button} from "@mui/material";
import ModalSendMessage from "./ModalSendMessage";
import {Editor} from 'react-draft-wysiwyg';
import {EditorState} from 'draft-js';
import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import ContentState from "draft-js/lib/ContentState";
import htmlToDraft from 'html-to-draftjs';
import useAccountValidation from "../../hooks/useAccountValidation";
import { PROFIL } from '../../constants/enum';

const css = {
	classicInput: {border: 'none', outline: 'none', width: '90%'},
	noMessage: {color: 'white', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px'},
	iconNewMessage: {color: 'white', position: 'relative', left: '7px'},
	btnActions: {margin: '10px', height: '30px', fontSize: '13px', padding: '10px'},
	messageContent: {padding: '15px', overflow: 'auto', height: '100%'}
}

const Messagerie = (props) => {
	const alert = useAlert();
	const navigate = useNavigate();
	const nbMessage = useMessage();
	const nbAccount = useAccountValidation();
	const [authz, user, profil] = useAuthz();
	const [isLoading, setIsLoading] = useState(true);
	const [messages, setMessages] = useState([]);
	const [selectedMessage, setSelectedMessage] = useState(null);
	const [selectedValue, setSelectedValue] = useState({filterSelected: 1});
	const [openModal, setOpenModal] = useState(false);
	const [editorState, setEditorState] = useState(EditorState.createEmpty());

	//#region useEffect

	useEffect(() => {
		document.title = `TE - Messagerie`;
	}, []);
	useEffect(() => {
		if (!openModal) apiLoadUserMessages();
	}, [selectedValue, openModal]);
	useEffect(() => {
		if (selectedMessage) {
			const contentBlock = htmlToDraft(selectedMessage.tchat.message);
			setEditorState(EditorState.createWithContent(ContentState.createFromBlockArray(contentBlock.contentBlocks)));
		}
	}, [selectedMessage])

	//#endregion

	//#region API

	const apiLoadUserMessages = () => {
		axios({method: 'get', url: URL_API + '/messagerie/messages', params: {userId: user.user_id, type: selectedValue.filterSelected}})
			.then((response) => {
				setMessages(response.data);
				setIsLoading(false);
			})
			.catch((error) => {
				logError(alert, error);
				setIsLoading(false);
			});
	};
	const apiReadingMessage = () => {
		axios({method: 'put', url: URL_API + '/messagerie/lecture-message', params: {tchatId: selectedMessage.tchat_id, userId: user.user_id}})
			.then((response) => {
				setSelectedMessage(response.data);
				apiLoadUserMessages();
				setIsLoading(false);
				alert.removeAll();
				alert.success('Le message a été marqué comme lu avec succés');
			})
			.catch((error) => {
				logError(alert, error);
				setIsLoading(false);
			});
	};
	const apiArchivingMessage = () => {
		axios({
			method: 'delete',
			url: URL_API + '/messagerie/archivage',
			params: {tchatId: selectedMessage.tchat_id, userId: user.user_id}
		})
			.then((response) => {
				setSelectedMessage(response.data);
				apiLoadUserMessages();
				setIsLoading(false);
				alert.removeAll();
				alert.success('Le message a été archivé avec succés');
			})
			.catch((error) => {
				logError(alert, error);
				setIsLoading(false);
			});
	};

	//#endregion

	//#region Fonctions

	const handleOpenMessage = (aMessage) => {
		setSelectedMessage(aMessage);
	};
	const handleSetMessageIsRead = () => {
		setIsLoading(true);
		apiReadingMessage();
	};
	const handleArchiveMessage = () => {
		setIsLoading(true);
		apiArchivingMessage();
	};
	const handleChangeFilter = (e) => {
		setSelectedValue({...selectedValue, [e.target.name]: e.target.value})
	};
	const handleGoToRequestPass = (requestPassId) => {
		navigate(`/demande-passage/dossier?id=${requestPassId}`);
	};
	const handleGoToPlanification = (planificationId) => {
		navigate(`/planification?planificationId=${planificationId}`);
	}
	const handleCreateMessage = () => {
		setOpenModal(true);
	};

	const formatAuthor = (author) => {
		if (user.id_profil !== PROFIL.ADMINISTRATEUR && user.id_profil !== PROFIL.GESTIONNAIRE && user.id_profil !== PROFIL.INTERVENANT) {
			switch (author.id_profil) {
				case PROFIL.ADMINISTRATEUR:
					return 'Administrateur';
				case PROFIL.GESTIONNAIRE:
					return 'Gestionnaire';
				case PROFIL.INTERVENANT:
					return 'Intervenant';
				case PROFIL.CLIENT:
					return 'Client';
				default:
					return author.login;
			}
		} else {
			return author.login;
		}
	}

	//#endregion

	//#region Render

	return (
		<div style={{height: '100%'}}>
			<TopBar title='Messagerie' className='topbar-contenu' color={props.params.color}
							buttons={
								<div className='topbar-buttons'>
									{/*<MyButton label={'Nouveau message'}*/}
									{/*					style={'buttonDefault'}*/}
									{/*					icon={faPaperPlane}*/}
									{/*					onClick={handleCreateMessage} />*/}
								</div>
							}
							filterContainer={
								<>
									<MySelect name={"filterSelected"} label={"Filtre"}
														datas={[{key: 1, value: 'Boite de réception'}, {key: 2, value: 'Messages archivés'}]}
														style={css.classicInput}
														value={selectedValue.filterSelected} handleChange={handleChangeFilter}/>
								</>
							}
			/>

			<div style={{display: 'flex', alignItems: isLoading ? 'center' : '', margin: 0, height: 'calc(100% - 50px)'}}>
				<ClipLoader color='#0094ca' loading={isLoading} size={75} css={'display: flex; margin: 25px;justify-content: center;'}/>

				{!isLoading && (
					<>
						<div className='tchat-menu-left'>
							{messages.length === 0 && (<div style={css.noMessage}>Vous n'avez aucun message</div>)}
							{messages.map((aMessage) => {
								return (
									<div
										className='tchat-message-title'
										onClick={() => handleOpenMessage(aMessage)}
										key={'message-' + aMessage.id}
										style={{
											borderLeft: aMessage.id === selectedMessage?.id ? '10px solid #0094ca96' : '10px solid #fff0',
											backgroundColor: aMessage.id === selectedMessage?.id ? '#0094ca36' : '',
										}}
									>
										<div className='message-bar-message-icon'>
											{!aMessage.is_read &&
												<FontAwesomeIcon icon={faEnvelopeOpenText} style={css.iconNewMessage}/>
											}
										</div>
										<div className='message-bar-message-text'>
											<div className='message-bar-message-title'>{aMessage.tchat.title}</div>
											<div className='message-bar-message-subtitle'>
												le {moment(aMessage.tchat.date_message).format('DD/MM/YYYY à HH:mm')}
												<br/>
												par {formatAuthor(aMessage.tchat.account)}
											</div>
										</div>
										<FontAwesomeIcon icon={faChevronRight} className="message-bar-message-chevron" />
									</div>
								);
							})}
						</div>
						<div className='tchat-content'>
							{selectedMessage != null && (
								<>
									<div className='tchat-content-header'>
										<div style={{display: 'flex', flexDirection: 'row'}}>
											<div className='tchat-content-title'>{selectedMessage?.tchat?.title}</div>
											<div className='tchat-content-actions'>
												<MyButton onClick={handleSetMessageIsRead} style={'smallDefaultButton'}
																	label={selectedMessage.is_read ? "Marquer comme non lu" : "Marquer comme lu"}
																	icon={selectedMessage.is_read ? faEyeSlash : faEye}
												/>
												<MyButton onClick={handleArchiveMessage} style={'smallDefaultButton'}
																	label={selectedMessage.deleted ? "Désarchiver" : "Archiver"}
																	icon={selectedMessage.deleted ? faTrashRestore : faTrash}
												/>
												{
													selectedMessage.tchat.dossier_id &&
													<MyButton onClick={() => handleGoToRequestPass(selectedMessage.tchat.dossier_id)} style={'smallDefaultButton'}
																		label="Accéder au dossier"
																		icon={faFolderOpen}
													/>
												}
												{
													selectedMessage.tchat.planification_id &&
													<MyButton onClick={() => handleGoToPlanification(selectedMessage.tchat.planification_id)} style={'smallDefaultButton'}
																		label="Accéder à la demande de passage"
																		icon={faFolderOpen}
													/>
												}
											</div>
										</div>
										<div style={{height: 30, paddingLeft: '15px', fontSize: '11px'}}>
											Envoyé par <b>{formatAuthor(selectedMessage.tchat.account)}</b> à <b>{selectedMessage.account.email}</b>,
											le {moment(selectedMessage.tchat.date_message).format('DD/MM/YYYY à HH:mm')}
											<br/>
											{selectedMessage.tchat.dossier_id ? `Demande de passage n°${selectedMessage.tchat.dossier_id}` : ''}
										</div>
									</div>
									{/*{selectedMessage?.tchat?.message}*/}
									<div style={css.messageContent}>
										<Editor
											editorState={editorState}
											wrapperClassName="demo-wrapper"
											editorClassName="demo-editor"
											onEditorStateChange={setEditorState}
											defaultContentState={selectedMessage?.tchat?.message}
											readOnly
										/>
									</div>
								</>
							)}
						</div>
					</>
				)}
			</div>

			<ModalSendMessage openModal={openModal} setOpenModal={setOpenModal} color={props.params.color} user={user}/>
		</div>
	);

	//#endregion

};

export default Messagerie;
